<template>
  <div v-if="result.mfa">
    <email
      v-if="result.mfa.type === 'email'"
      :session-id="sessionId"
      :result="result"
      @result="$emit('result', $event)"
      @error="$emit('error')"
    />
    <auth-app
      v-if="result.mfa.type === 'auth_app'"
      :session-id="sessionId"
      :result="result"
      @result="$emit('result', $event)"
      @error="$emit('error')"
    />
    <sms
      v-else-if="result.mfa.type === 'sms'"
      :session-id="sessionId"
      :result="result"
      @result="$emit('result', $event)"
      @error="$emit('error')"
    />
    <other-device-approval
      v-else-if="result.mfa.type === 'other_device'"
      :session-id="sessionId"
      :result="result"
      @result="$emit('result', $event)"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { LoginResult } from '.';
import Email from './Email.vue';
import AuthApp from './AuthApp.vue';
import Sms from './Sms.vue';
import OtherDeviceApproval from './OtherDeviceApproval.vue';

export default defineComponent({
  emits: ['error', 'result'],
  components: {
    Email,
    AuthApp,
    Sms,
    OtherDeviceApproval,
  },
  props: {
    sessionId: {
      type: String,
      required: true,
    },
    result: {
      type: Object as () => LoginResult,
      required: true,
    },
  },
});
</script>
